module.exports = __webpack_public_path__ + "static/img/kaojichi.84adc3fe.png";